import styled, { css } from 'styled-components';
import { colors, media } from 'tsx/theme';

const arrow = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAYAAAAVMmT4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADBSURBVHgBfc0xCsJAEAXQPy6Wgoj2ARXsVCxEbHIEc4OoOUASc4AcQEhKC8EcQU8QU2lnSlGLHEAhaCes6yoEgoXTzfzHfECO0XJU/JksZ0bDUYUQYbc6wOG2i37hpGl7EFj0KsOIvoeGbRKRB8KaP0vjIHFTU3HL9+LDk0AnQdbyMvcp+zCtz0YoYAVQQgwWODwBoUioSbj9GMpX6i1TYS8WylpFrgkH14KzH2c5y+P4uk/btf6GCdbhTMKTf8znb6MgP6mWHuanAAAAAElFTkSuQmCC`;

interface Props {
  error?: boolean;
  $hasValue?: boolean;
}

export const SelectVerdigris = styled.select<Props>`
  border: 1px solid ${colors.colorVerdigrisDark};
  height: 48px;
  border-radius: 50px;
  padding: 0 15px;
  font-size: 16px;

  color: ${colors.colorVerdigrisDark};

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;

  background: url(${arrow}) right 20px center / 12px 7px no-repeat;

  ${({ $hasValue }) =>
    !$hasValue &&
    css`
      color: #3535357c;
    `}

  option[value=''] {
    display: none;
  }

  &:focus {
    outline: 1px solid ${colors.colorVerdigrisDark};
  }

  &:hover {
    outline: 1px solid ${colors.colorVerdigrisDark};
  }

  ${({ error }) =>
    error &&
    css`
      border: 1px solid red;
      &:focus {
        outline: 1px solid red;
      }
      &:hover {
        outline: 1px solid red;
      }
    `};

  ${media.md(css`
    height: 35px;
    font-size: 14px;
    width: 100%;
  `)}
`;
